import { BrandConfig } from '../types';

export const accesElevationBrand: BrandConfig = {
  key: 'acces-elevation',
  name: 'Accès Élévation',
  shortName: 'Accès Élévation',
  tagline: 'Propulsez votre autonomie · Québec',
  colors: {
    primary: '#F27405',
    primaryHover: '#D96504',
    navy: '#1B365D',
    navyDark: '#0F1923',
    blueAccent: '#004A8D',
  },
  fonts: {
    displayName: 'Bricolage Grotesque',
    bodyName: 'Plus Jakarta Sans',
    googleFontsUrl:
      'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,700;12..96,800&family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap',
  },
  contact: {
    phone: '1-877-888-4142',
    email: 'info@acceselevation.ca',
    website: 'https://acceselevation.ca',
  },
  pdfHeaderSubtitle: "Rampes d'accès & accessibilité · Québec",
  pwaManifest: {
    name: 'Soumission Accès Élévation',
    short_name: 'Accès Élévation',
    theme_color: '#F27405',
    background_color: '#FAFAFA',
    icon_192: '/brands/acces-elevation/logo.png',
    icon_512: '/brands/acces-elevation/logo.png',
  },
};
